import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby-link';

import { BaseSubheading, CalloutXs } from '@styled-components/Typography';

const Arrow = ({ className }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 17 8"
			fill="none"
			className={className}
		>
			<path d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4V4.5H16V4V3.5H0V4Z" />
		</svg>
	);
};

const StatWrapper = styled(Link)`
	background-color: ${({ theme }) => theme.colors.cream.dark};
	border-radius: 16px;
	width: fit-content;
	display: grid;
	grid-template-columns: 1fr 0px;
	padding: 2.4rem 3.2rem;
	margin-bottom: 3rem;
	color: ${({ theme }) => theme.colors.black.main};
	text-decoration: none;
	transition: all 0.75s ease;
	align-items: center;
	gap: 2.4rem;

	.divider {
		background: ${({ theme }) => theme.colors.black.main};
		transition: background 0.75s ease;
	}

	h5,
	span {
		color: ${({ theme }) => theme.colors.black.main};
		transition: color 0.75s ease;
	}

	svg {
		g,
		path {
			fill: ${({ theme }) => theme.colors.black.main};
			transition: fill 0.75s ease;
		}
	}

	.animated-block__arrow {
		width: 0;
		height: 0;
		transition: all 0.75s ease;
	}

	:hover {
		background-color: ${({ theme }) => theme.colors.secondary.main};
		grid-template-columns: 1fr 30px;

		h5,
		span {
			color: ${({ theme }) => theme.colors.white.main};
		}

		svg {
			g,
			path {
				fill: ${({ theme }) => theme.colors.white.main};
			}
		}

		.divider {
			background: ${({ theme }) => theme.colors.white.main};
		}

		.animated-block__arrow {
			width: 30px;
			height: 30px;
		}
	}
`;

const StatGrid = styled.div`
	display: grid;
	grid-template-columns: auto 1px auto;
	gap: 2.4rem;
	align-items: center;
`;

const StatLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1.5rem 0;

	svg {
		width: 100%;
		height: auto;
		max-width: 130px;
		max-height: 60px;
	}

	img {
		width: 100%;
		max-width: 150px;
	}
`;

const Divider = styled.div`
	height: 100%;
	width: 1px;
	background: ${({ theme }) => theme.colors.black.main};
`;

const StatRight = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
	padding: 1.5rem 0;
`;

const StatTextCallout = styled(BaseSubheading)`
	font-size: 3rem;
	line-height: 125%; /* 37.5px */
	letter-spacing: 0.3px;
	margin: 0;
`;

const StatTextDescription = styled(CalloutXs)`
	margin: 0;
`;

const AnimatedStatBlockLink = ({ stat }) => {
	return (
		<StatWrapper to={stat.linkUrl}>
			<StatGrid>
				<StatLeft>
					{stat?.statisticIcon?.file?.contentType === 'image/svg+xml' ? (
						<div
							dangerouslySetInnerHTML={{
								__html: stat?.statisticIcon?.svg.content,
							}}
						/>
					) : (
						<img
							src={stat?.statisticIcon?.file.url}
							alt={stat.statisticIcon?.description}
						/>
					)}
				</StatLeft>
				<Divider className="divider" />
				<StatRight>
					<StatTextCallout as="h5">
						{stat.statistic} {stat.statisticSubdescription}
					</StatTextCallout>
					<StatTextDescription>
						{stat.statisticDescription.statisticDescription}
					</StatTextDescription>
				</StatRight>
			</StatGrid>
			<Arrow className="animated-block__arrow" />
		</StatWrapper>
	);
};

export default AnimatedStatBlockLink;
